<h2 mat-dialog-title>
  <mat-icon class="title-icon">content_copy</mat-icon>
  Copy Resource
</h2>

<mat-dialog-content>
  <div class="copy-resource-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Name</mat-label>
      <input matInput [(ngModel)]="data.name" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Capacity</mat-label>
      <input matInput type="number" [(ngModel)]="data.capacity" min="1" [max]="getMaxCapacity() || 999" required>
      <mat-hint *ngIf="getMaxCapacity()">Maximum capacity: {{getMaxCapacity()}}</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Resource Type</mat-label>
      <input matInput [value]="getResourceTypeName()" disabled>
    </mat-form-field>

    <!-- Custom Attributes Section -->
    <div *ngIf="resourceTypeHasAttributes()" class="attributes-section">
      <h3>Attributes</h3>
      
      <div *ngFor="let attribute of getResourceTypeAttributes()" class="attribute-field">
        <!-- Text input -->
        <mat-form-field *ngIf="attribute.type === 'text'" appearance="outline" class="full-width">
          <mat-label>{{ attribute.name }}</mat-label>
          <input matInput [(ngModel)]="attributeValues[attribute.id]">
        </mat-form-field>

        <!-- Number input -->
        <mat-form-field *ngIf="attribute.type === 'number'" appearance="outline" class="full-width">
          <mat-label>{{ attribute.name }}</mat-label>
          <input matInput type="number" [(ngModel)]="attributeValues[attribute.id]">
        </mat-form-field>

        <!-- Checkbox -->
        <div *ngIf="attribute.type === 'checkbox'" class="checkbox-field">
          <mat-checkbox 
            [checked]="attributeValues[attribute.id] === 'true'"
            (change)="attributeValues[attribute.id] = $event.checked ? 'true' : 'false'">
            {{ attribute.name }}
          </mat-checkbox>
        </div>

        <!-- Select dropdown -->
        <mat-form-field *ngIf="attribute.type === 'select'" appearance="outline" class="full-width">
          <mat-label>{{ attribute.name }}</mat-label>
          <mat-select [(ngModel)]="attributeValues[attribute.id]">
            <mat-option *ngFor="let option of getSelectOptions(attribute)" [value]="option.slug">
              {{ option.display }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Availability Section -->
    <div class="availability-section">
      <div class="availability-header">
        <mat-checkbox [(ngModel)]="copyAvailability">
          Copy Availability
        </mat-checkbox>
      </div>

      <div class="availability-preview" *ngIf="copyAvailability && !loadingAvailability">
        <label class="section-label">Availability blocks to copy:</label>
        <app-availability-blocks
          [availability]="sourceAvailability"
          [compact]="false"
          [maxBlocks]="0">
        </app-availability-blocks>
      </div>

      <div class="loading-availability" *ngIf="loadingAvailability">
        <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
        <span>Loading availability...</span>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSubmit()" [disabled]="!data.name">
    Create Copy
  </button>
</mat-dialog-actions>